<template>
  <div id="app">
    <h1>Olympus Mobile App Assets</h1>
    <ul class="icons">
      <li class="icon" v-for="icon in icons" :key="icon">
        <img :src="`/icons/${icon}.svg`" class="icon__image" />
        <div class="icon__label">{{ icon }}</div>
        <div class="icon__links">
          <a :href="`/icons/${icon}.svg`" class="icon__link" download>SVG</a>
          <a :href="`/icons/${icon}.png`" class="icon__link" download>PNG</a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
const iconsContext = require.context(
  '../public/icons',
  false,
  /[A-Za-z-]\w+\.(svg)$/
)
const icons = iconsContext.keys().map(icon => {
  return icon.replace('./', '').replace(/\.[^/.]+$/, '')
})

export default {
  name: 'app',
  data: () => ({
    icons
  })
}
</script>

<style>
:root {
  font-size: 62.5%;
}

body {
  box-sizing: border-box;
  font: 1.4rem/1.6rem -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol';
  margin: 2.4rem;
}

body *,
body *:before,
body *:after {
  box-sizing: inherit;
}

h1 {
  font-size: 2.4rem;
  line-height: 3.2rem;
  margin-bottom: 2.4rem;
  text-align: center;
}

.icons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style-type: none;
  margin: -0.8rem;
  padding: 0;
}

.icon {
  align-items: center;
  background: #f0f2f3;
  border-radius: 0.4rem;
  display: flex;
  flex-direction: column;
  margin: 0.8rem;
  padding: 1.6rem 0.8rem;
  text-align: center;
  width: 16rem;
}

.icon__image {
  display: block;
  margin: 0.8rem 0;
}

.icon__label {
  font-size: 1.2rem;
}

.icon__links {
  display: flex;
  margin-top: 0.8rem;
}

.icon__link {
  background: #fff;
  color: inherit;
  padding: 0.2rem 0.4rem;
  text-decoration: none;
}

.icon__link:not(:last-child) {
  margin-right: 0.8rem;
}
</style>
